// extracted by mini-css-extract-plugin
module.exports = {"mobileLangSelect":"styles_mobileLangSelect__1rsXI"};